
import * as constants from "../../assets/constants";
import {baseApi} from "../BaseApi";


class SalePointTypesApi extends baseApi {

    getList = async () => {
        return await this.get('?app=salepointtypes&act=getList')
    }

}

export default new SalePointTypesApi(constants.DEBUG?constants.base_url_stage:constants.base_url_prod);

